import { useEffect, useState } from 'react';
import { EnvelopeSimple, User } from 'shared/icons';
import api from '../../services/api';
import Button from '../ui/Button';
import Input from '../ui/Input';
import Modal from '../ui/Modal';

const EditProfileModal = ({ isOpen, onClose, currentUser, onSuccess }) => {
    const [formData, setFormData] = useState({
        full_name: '',
        email: '',
    });
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (currentUser) {
            setFormData({
                full_name: currentUser.full_name || '',
                email: currentUser.email || '',
            });
        }
    }, [currentUser]);

    const handleClose = () => {
        setErrors({});
        onClose();
    };

    const validateForm = () => {
        const nextErrors = {};

        if (!formData.full_name || formData.full_name.trim().length < 3) {
            nextErrors.full_name = 'Nome deve ter no minimo 3 caracteres';
        }

        if (!formData.email) {
            nextErrors.email = 'Email e obrigatorio';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            nextErrors.email = 'Email invalido';
        }

        setErrors(nextErrors);
        return Object.keys(nextErrors).length === 0;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!validateForm()) {
            return;
        }

        try {
            setLoading(true);
            await api.updateProfile({
                full_name: formData.full_name.trim(),
                email: formData.email.trim(),
            });

            onSuccess?.('Perfil atualizado com sucesso');
            handleClose();
        } catch (error) {
            setErrors({ submit: error?.message || 'Erro ao atualizar perfil' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleClose}
            title="Editar Perfil"
            icon={<User size={24} className="text-black dark:text-white" />}
            size="md"
        >
            <form onSubmit={handleSubmit} className="space-y-4">
                <div className="relative">
                    <Input
                        label="Nome Completo"
                        value={formData.full_name}
                        onChange={(event) =>
                            setFormData((previous) => ({ ...previous, full_name: event.target.value }))
                        }
                        placeholder="Digite seu nome completo"
                        className="pl-10"
                        error={errors.full_name}
                    />
                    <User size={18} className="absolute left-3 top-[38px] text-mono-500 pointer-events-none" />
                </div>

                <div className="relative">
                    <Input
                        label="Email"
                        type="email"
                        value={formData.email}
                        onChange={(event) => setFormData((previous) => ({ ...previous, email: event.target.value }))}
                        placeholder="seu@email.com"
                        className="pl-10"
                        error={errors.email}
                    />
                    <EnvelopeSimple
                        size={18}
                        className="absolute left-3 top-[38px] text-mono-500 pointer-events-none"
                    />
                </div>

                {errors.submit ? (
                    <div className="p-3 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg">
                        <p className="text-sm text-red-500 dark:text-red-400">{errors.submit}</p>
                    </div>
                ) : null}

                <div className="flex gap-3 pt-2">
                    <Button
                        type="button"
                        variant="secondary"
                        onClick={handleClose}
                        className="flex-1"
                        disabled={loading}
                    >
                        Cancelar
                    </Button>
                    <Button type="submit" className="flex-1" loading={loading}>
                        Salvar
                    </Button>
                </div>
            </form>
        </Modal>
    );
};

export default EditProfileModal;
